import FunctionalStar from './FunctionalStar';

export const initStars = (): FunctionalStar[][] => [[], [], [], [], [], [], [], [], [], [], [], []];

export * from './location';
export * from './majorStar';
export * from './minorStar';
export * from './adjectiveStar';
export * from './decorativeStar';
export * from './horoscopeStar';
